import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { ThreatAssessmentSummaryService } from '../../../../shared/services/threatAssessment.service';

@Component({
  selector: 'review-threat-assessment-summary',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-threat-assessment-summary.component.html',
  styleUrl: './review-threat-assessment-summary.component.css'
})
export class ReviewThreatAssessmentSummaryComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  threatAssessmentSummary: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Threat Assessment Info",
      children: [
        {
          type: 'number',
          questionText: "A Behavioral Threat Assessment Screening was completed during this assessment:",
          answer: "behavioral_screen_complete_during"
        },
        {
          type: 'number',
          questionText: "A Full-Team Behavioral Threat Assessment was completed during this assessment:",
          answer: "full_team_threat_assessment_complete_during"
        },
        {
          type: 'string',
          questionText: "Provide a summary of the threat or situation that was reviewed:",
          answer: "situation_summary"
        },
        {
          type: 'string',
          questionText: "Provide a summary of the Response, Management, and Support Plan implemented by the team:",
          answer: "rms_summary"
        },
        {
          type: 'string',
          questionText: "Copies have and/or will be sent to:",
          answer: "send_to"
        },
        {
          type: 'string',
          questionText: "Please list where other copies are sent:",
          answer: "send_to_other"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "date_time_signed"
        }
      ]
    },
  ];

  constructor(
    private threatAssessmentSummaryService: ThreatAssessmentSummaryService
  ) { }

  ngOnInit(): void {
    this.loadThreatAssessmentSummary();
  }
  loadThreatAssessmentSummary(): void {
    if (this.caseId) {
      this.loading = true;
      this.threatAssessmentSummaryService.getThreatAssessmentSummaryByCaseId(this.caseId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.threatAssessmentSummary = null;
            this.loading = false;
            return
          } else {
            this.threatAssessmentSummary = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }


}
